import {DomainObject, oneOf} from 'shared/store';
import {action, computed, observable} from 'mobx';

class ClockEvent extends DomainObject {
  @observable eventType;
  @observable createdAt;
  @observable location;
  @observable withinGeofence;
  @observable geofenceLocation;
  @observable projectId;
  @observable projectName;
  @observable note;

  @action merge(other) {
    super.merge(other, {
      eventType: oneOf(['clock_in', 'clock_out'])
    });
  }

  @computed get isClockIn() {
    return this.eventType === 'clock_in';
  }
}

export default ClockEvent;
